// Las columnas date() de drizzle se serializan como ISO datetime completo
// (ej. "2026-07-18T00:00:00.000Z"), NO como "YYYY-MM-DD" simple — gotcha
// documentado en context.md. Los campos calculados vía luxon toISODate()
// (ej. vencimiento en CxC) sí devuelven fecha simple. Un <input type="date">
// solo acepta el segundo formato, y new Date(`${x}T12:00:00`) revienta con el
// primero ("Invalid Date"). Mismo bug corregido puntualmente 3+ veces antes de
// este helper (fecha_factura/fecha_pago en CxC — F.6.2; fecha_primer_reporte
// en Plataformas — Prompt H) — usar SIEMPRE estos dos, nunca repetir la lógica.

export function toDateInputValue(isoOrNull: string | null | undefined): string {
  if (!isoOrNull) return '';
  const soloFecha = isoOrNull.slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(soloFecha) ? soloFecha : '';
}

export function fmtFechaDisplay(isoOrNull: string | null | undefined): string {
  const soloFecha = toDateInputValue(isoOrNull);
  if (!soloFecha) return '—';
  const d = new Date(`${soloFecha}T12:00:00`);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('es-MX', { day: '2-digit', month: '2-digit', year: 'numeric' });
}
